import {EDefaultValueRuleType} from 'components/form/hooks/field-default-value.hook';
import {IFieldMeta, EFieldType, getFormInitValue} from 'entities/metadata';
import {IContextRawData} from 'modules/context/context-types';
import {TEntity, TEntityValue, selectEntityData} from 'modules/data';
import {ALLOWED_BOOL_VALUES, BOOL_VALUE_WITH_TABLE} from 'modules/data/data-constants';
import {EEntityType} from 'shared/constants/entities';
import {TAppState} from 'store/config/types';

export const normalizeEntityName = (
    entityName: string,
): string => entityName.replace(/^app\./, '');

export const normalizeBoolValue = (value?: TEntityValue): boolean => {
    const normalizedString: string = String(value?.toString().toLowerCase());
    return ALLOWED_BOOL_VALUES[normalizedString];
};

export const normalizeBoolValueString = (value?: boolean): string => {
    const normalizedString: string = String(value?.toString().toLowerCase());
    return BOOL_VALUE_WITH_TABLE[normalizedString];
};

export const getContextDataValueByRule = (defaultValueByRule: string, contextData: IContextRawData) => {
    switch (defaultValueByRule) {
    case EDefaultValueRuleType.USER_TAX_PERIOD:
        return contextData?.taxPeriodId || undefined;

    case EDefaultValueRuleType.USER_ORGANIZATION:
        return contextData?.organizationId || undefined;

    default:
        return undefined;
    }
};
export const getBlankForm = (fields: IFieldMeta[], getState?: () => TAppState, contextData?: IContextRawData) => fields
    .reduce((acc: TEntity, field: IFieldMeta) => {
        if (field?.key) {
            acc[field.key] = field.defaultValue || getFormInitValue(field.type);
        }
        if (Array.isArray(field?.additionalInputOptions)) {
            field?.additionalInputOptions?.forEach(input => {
                if (!input?.isFiltrationEnabled && input.key) acc[input.key] = input?.value;
            });
        }
        if (
            field?.key
            && field?.defaultValueByRule
            && contextData
        ) {
            acc[field.key] = getContextDataValueByRule(field?.defaultValueByRule, contextData);
        }
        if (
            field?.key && field.type === EFieldType.REFERENCE
            && field?.defaultValue === 'Y'
            && field?.referenceUrl
            && getState
        ) {
            const referenceData: any = selectEntityData(field.referenceUrl, EEntityType.REFERENCE)(getState());
            acc[field.key] = referenceData?.rows[0];
        }
        return acc;
    }, {});
